import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = [
    "uploadForm",
    "uploading",
    "error",
    "file",
    "form",
    "selectButton",
    "uploadButton",
    "filenameList",
    "uploadFormContainer",
    "hipaaAuthContainer",
    "uploadStatusTitle",
    "uploadStatusMessage"
  ];

  initialize() {
    this.boundStartUpload = this.startUpload.bind(this)
    this.boundEndUpload = this.endUpload.bind(this)
    this.boundErrorUpload = this.errorUpload.bind(this)
    this.fileList = new DataTransfer()
  }

  connect() {
    this.uploadingTarget.classList.add("hidden")
    this.errorTarget.classList.add("hidden")

    document.addEventListener("direct-uploads:start", this.boundStartUpload)
    document.addEventListener("direct-uploads:end", this.boundEndUpload)
    document.addEventListener("direct-upload:error", this.boundErrorUpload)
  }


  disconnect() {
    document.removeEventListener("direct-uploads:start", this.boundStartUpload)
    document.removeEventListener("direct-uploads:end", this.boundEndUpload)
    document.removeEventListener("direct-uploads:error", this.boundErrorUpload)
  }

  startUpload(e) {
    // Handle situations where there are 2+ forms on the page.
    if (e.target !== this.formTarget) {
      return;
    }
    this.filenameListTarget.classList.add("hidden")
    this.selectButtonTarget.classList.add("hidden")
    this.uploadingTarget.classList.remove("hidden")

    setTimeout(() => {
      if (this.uploadStatusTitleTarget) {
        this.uploadStatusTitleTarget.innerText = "Merging your files..."
      }

      setTimeout(() => {
        if (this.uploadStatusTitleTarget) {
          this.uploadStatusTitleTarget.innerText = "Extracting data..."
        }

        setTimeout(() => {
          if (this.uploadStatusTitleTarget) {
            this.uploadStatusTitleTarget.innerText = "Analyzing for required data..."
          }
        }, 5000)
      }, 5000)
    }, 5000);

    if (rails_env == "production") {
      var index = 0;
      var start = new Date().getTime();
      var interval = setInterval(() => {
        index += 1;
        var uploadingElement = this.uploadingTarget.querySelector("[data-uploading]");
        if (uploadingElement) {
          // console.log("Still uploading");
          if (index % 5 == 0 && index <= 600) {
            fetch("/api/v1/metrics/increment_counter?name=bill_documents.still_uploading_at_" + index + "_seconds", { method: "POST" });
          }
        } else {
          // console.log("Done uploading!");
          // console.log("Time: " + time);
          var finish = new Date().getTime();
          var seconds = (finish - start) / 1000.0;
          fetch("/api/v1/metrics/add_distribution_value?name=bill_documents.upload_time&value=" + seconds, { method: "POST" });
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  endUpload(e) {
    // Handle situations where there are 2+ forms on the page.
    if (e.target !== this.formTarget) {
      return;
    }
  }

  errorUpload() {
    this.uploadingTarget.classList.add("hidden")
    this.errorTarget.classList.remove("hidden")
  }

  selectButtonClicked(event) {
    this.fileTarget.click()
  }

  fileChanged(event) {
    for (var i = 0; i < this.fileTarget.files.length; i++) {
      var f = this.fileTarget.files[i]
      this.fileList.items.add(f)

      var reader = new FileReader()
      reader.onload = () => { this.loadImage(this.filenameListTarget, reader, f) }
      reader.readAsDataURL(f)

      this.filenameListTarget.classList.remove("hidden")
    }

    this.selectButtonTarget.innerText = "Select another"
    this.uploadButtonTarget.disabled = false
    this.uploadButtonTarget.classList.remove("hidden")
  }

  uploadButtonClicked(event) {
    this.fileTarget.files = this.fileList.files

    this.uploadFormTarget.classList.add("hidden")

    this.uploadingTarget.classList.remove("hidden")

    Rails.fire(this.formTarget, "submit")
  }

  loadImage(fnListTarget, reader, f, idx) {
    var str = "<li class=\"flex items-center gap-2 mb-2\"><img src='"
    var lowerName = f.name.toLowerCase();
    if (lowerName.endsWith(".pdf")) {
      str += "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMTZWNUM2IDQuNzM0NzggNi4xMDUzNiA0LjQ4MDQzIDYuMjkyODkgNC4yOTI4OUM2LjQ4MDQzIDQuMTA1MzYgNi43MzQ3OCA0IDcgNEgxOUwyNiAxMVYxNiIgc3Ryb2tlPSIjNTY2MEZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkgNFYxMUgyNiIgc3Ryb2tlPSIjNTY2MEZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNiAyNUg4QzguNTMwNDMgMjUgOS4wMzkxNCAyNC43ODkzIDkuNDE0MjEgMjQuNDE0MkM5Ljc4OTI5IDI0LjAzOTEgMTAgMjMuNTMwNCAxMCAyM0MxMCAyMi40Njk2IDkuNzg5MjkgMjEuOTYwOSA5LjQxNDIxIDIxLjU4NThDOS4wMzkxNCAyMS4yMTA3IDguNTMwNDMgMjEgOCAyMUg2VjI3IiBzdHJva2U9IiM1NjYwRkIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNyAyMUgyMy41VjI3IiBzdHJva2U9IiM1NjYwRkIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi41IDI0LjVIMjMuNSIgc3Ryb2tlPSIjNTY2MEZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYgMjdDMTYuNzk1NiAyNyAxNy41NTg3IDI2LjY4MzkgMTguMTIxMyAyNi4xMjEzQzE4LjY4MzkgMjUuNTU4NyAxOSAyNC43OTU2IDE5IDI0QzE5IDIzLjIwNDQgMTguNjgzOSAyMi40NDEzIDE4LjEyMTMgMjEuODc4N0MxNy41NTg3IDIxLjMxNjEgMTYuNzk1NiAyMSAxNiAyMUgxNC4yNVYyN0gxNloiIHN0cm9rZT0iIzU2NjBGQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
    } else if (lowerName.endsWith(".heic") || lowerName.endsWith(".tif") || lowerName.endsWith(".tiff")) {
      str += "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDVINUM0LjQ2OTU3IDUgMy45NjA4NiA1LjIxMDcxIDMuNTg1NzkgNS41ODU3OUMzLjIxMDcxIDUuOTYwODYgMyA2LjQ2OTU3IDMgN1YyNUMzIDI1LjUzMDQgMy4yMTA3MSAyNi4wMzkxIDMuNTg1NzkgMjYuNDE0MkMzLjk2MDg2IDI2Ljc4OTMgNC40Njk1NyAyNyA1IDI3SDI3QzI3LjUzMDQgMjcgMjguMDM5MSAyNi43ODkzIDI4LjQxNDIgMjYuNDE0MkMyOC43ODkzIDI2LjAzOTEgMjkgMjUuNTMwNCAyOSAyNVY3QzI5IDYuNDY5NTcgMjguNzg5MyA1Ljk2MDg2IDI4LjQxNDIgNS41ODU3OUMyOC4wMzkxIDUuMjEwNzEgMjcuNTMwNCA1IDI3IDVaTTI3IDdWMTkuODQzOEwyMy43NDEyIDE2LjU4NjNDMjMuNTU1NSAxNi40MDA1IDIzLjMzNSAxNi4yNTMxIDIzLjA5MjMgMTYuMTUyNkMyMi44NDk3IDE2LjA1MiAyMi41ODk2IDE2LjAwMDMgMjIuMzI2OSAxNi4wMDAzQzIyLjA2NDIgMTYuMDAwMyAyMS44MDQxIDE2LjA1MiAyMS41NjE0IDE2LjE1MjZDMjEuMzE4NyAxNi4yNTMxIDIxLjA5ODIgMTYuNDAwNSAyMC45MTI1IDE2LjU4NjNMMTguNDEyNSAxOS4wODYzTDEyLjkxMjUgMTMuNTg2M0MxMi41Mzc1IDEzLjIxMTUgMTIuMDI5IDEzLjAwMDkgMTEuNDk4NyAxMy4wMDA5QzEwLjk2ODUgMTMuMDAwOSAxMC40NiAxMy4yMTE1IDEwLjA4NSAxMy41ODYzTDUgMTguNjcxMlY3SDI3Wk01IDIxLjVMMTEuNSAxNUwyMS41IDI1SDVWMjEuNVpNMjcgMjVIMjQuMzI4OEwxOS44Mjg4IDIwLjVMMjIuMzI4OCAxOEwyNyAyMi42NzI1VjI1Wk0xOCAxMi41QzE4IDEyLjIwMzMgMTguMDg4IDExLjkxMzMgMTguMjUyOCAxMS42NjY2QzE4LjQxNzYgMTEuNDIgMTguNjUxOSAxMS4yMjc3IDE4LjkyNiAxMS4xMTQyQzE5LjIwMDEgMTEuMDAwNiAxOS41MDE3IDEwLjk3MDkgMTkuNzkyNiAxMS4wMjg4QzIwLjA4MzYgMTEuMDg2NyAyMC4zNTA5IDExLjIyOTYgMjAuNTYwNyAxMS40MzkzQzIwLjc3MDQgMTEuNjQ5MSAyMC45MTMzIDExLjkxNjQgMjAuOTcxMiAxMi4yMDc0QzIxLjAyOTEgMTIuNDk4MyAyMC45OTkzIDEyLjc5OTkgMjAuODg1OCAxMy4wNzRDMjAuNzcyMyAxMy4zNDgxIDIwLjU4IDEzLjU4MjQgMjAuMzMzNCAxMy43NDcyQzIwLjA4NjcgMTMuOTEyIDE5Ljc5NjcgMTQgMTkuNSAxNEMxOS4xMDIyIDE0IDE4LjcyMDYgMTMuODQyIDE4LjQzOTMgMTMuNTYwN0MxOC4xNTggMTMuMjc5NCAxOCAxMi44OTc4IDE4IDEyLjVaIiBmaWxsPSIjNTY2MEZCIi8+Cjwvc3ZnPg=="
    } else {
      str += reader.result
    }

    var name = f.name
    if (name.length > 20) {
      var lastPeriod = name.lastIndexOf(".")
      name = name.substring(0, 10) + "..." + name.substring(lastPeriod)
    }
    str += "' class=\"h-16 max-w-[3rem] rounded-md border-solid border-2 border-medium-gray\" /> <span class=\"truncate w-full\">" + name + "</span></li>"
    fnListTarget.innerHTML += str
  }

}
